import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';
import { FaFacebookF, FaTwitter, FaYoutube, FaInstagram, FaPhone, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';
import { useSite } from '../context/SiteContext';
import api from '../services/api';
import './Footer.css';

const Footer = () => {
  const { config } = useSite();
  const [footerMenus, setFooterMenus] = useState([]);

  useEffect(() => {
    loadFooterMenus();
  }, []);

  const loadFooterMenus = async () => {
    try {
      const response = await api.get('/menus/', { params: { location: 'footer' } });
      setFooterMenus(response.data);
    } catch (error) {
      console.error('Error loading footer menus:', error);
    }
  };

  return (
    <footer className="site-footer">
      <div className="footer-main">
        <Container>
          <Row>
            <Col md={4} className="mb-4">
              <h5>About Us</h5>
              <p>{config?.site_tagline}</p>
              <div className="social-links">
                {config?.facebook_url && (
                  <a href={config.facebook_url} target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                    <FaFacebookF />
                  </a>
                )}
                {config?.twitter_url && (
                  <a href={config.twitter_url} target="_blank" rel="noopener noreferrer" aria-label="Twitter">
                    <FaTwitter />
                  </a>
                )}
                {config?.youtube_url && (
                  <a href={config.youtube_url} target="_blank" rel="noopener noreferrer" aria-label="YouTube">
                    <FaYoutube />
                  </a>
                )}
                {config?.instagram_url && (
                  <a href={config.instagram_url} target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                    <FaInstagram />
                  </a>
                )}
              </div>
            </Col>
            
            <Col md={4} className="mb-4">
              <h5>Quick Links</h5>
              <ul className="footer-menu">
                {footerMenus.map(menu => 
                  menu.items.map(item => (
                    <li key={item.id}>
                      <Link to={item.url}>{item.label}</Link>
                    </li>
                  ))
                )}
              </ul>
            </Col>
            
            <Col md={4} className="mb-4">
              <h5>Contact Us</h5>
              <div className="contact-info">
                {config?.address && (
                  <p><FaMapMarkerAlt className="me-2" />{config.address}</p>
                )}
                {config?.contact_phone && (
                  <p><FaPhone className="me-2" />{config.contact_phone}</p>
                )}
                {config?.contact_email && (
                  <p><FaEnvelope className="me-2" />{config.contact_email}</p>
                )}
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      
      <div className="footer-bottom">
        <Container>
          <div className="text-center">
            <p>&copy; {new Date().getFullYear()} {config?.site_name}. All rights reserved.</p>
            <p className="small">
              <Link to="/page/privacy-policy">Privacy Policy</Link> | 
              <Link to="/page/terms-and-conditions"> Terms & Conditions</Link>
            </p>
          </div>
        </Container>
      </div>
    </footer>
  );
};

export default Footer;
